__webpack_require__.p = "/assets/js/";